export default __webpack_public_path__ + "static/media/DISTRIBUCION_SECTION_IMG.9d34ed84.png";